// src/components/resources/tools/generators/ReviewMockup/AppStoreReviewCard.tsx
'use client'

import { Star } from 'lucide-react'
import { clsx } from 'clsx'
import type { AppStoreReviewItem } from './types'

/**
 * A single App Store review card (title, star row, recency, reviewer, body),
 * used for both the primary review and the stacked additional reviews.
 */
export function AppStoreReviewCard({
  title,
  body,
  rating,
  reviewerName,
  date,
}: AppStoreReviewItem): JSX.Element {
  return (
    <div className="py-3">
      <div className="flex items-start justify-between gap-3">
        <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
        <span className="flex-shrink-0 text-xs text-gray-400">{date}</span>
      </div>
      <div className="mt-1 flex items-center gap-2">
        <div className="flex items-center gap-0.5" aria-label={`Rating: ${rating} out of 5`}>
          {Array.from({ length: 5 }, (_, i) => (
            <Star
              key={i}
              className={clsx(
                'h-3 w-3',
                i < rating ? 'fill-orange-400 text-orange-400' : 'fill-gray-300 text-gray-300'
              )}
              aria-hidden="true"
            />
          ))}
        </div>
        <span className="text-xs text-gray-500">{reviewerName}</span>
      </div>
      <p className="mt-2 text-sm leading-relaxed text-gray-900">{body}</p>
    </div>
  )
}
